import { _ } from '@icc/shared/helpers';

// Zgłoszone, Ustalono datę odbioru, Anulowane, Odebrano
export type TransportStatus = 'requested' | 'date-set' | 'canceled' | 'collected';

export const TransportStatuses: Record<TransportStatus, string> = {
    requested: _('TRANSPORT|Zgłoszone'),
    'date-set': _('TRANSPORT|Ustalono datę odbioru'),
    collected: _('TRANSPORT|Odebrano'),
    canceled: _('TRANSPORT|Anulowane'),
};

export const TransportStatusesColors: Record<TransportStatus, string> = {
    requested: 'ffab45',
    'date-set': '8764b8',
    canceled: 'e74856',
    collected: '47d041',
};

export const transportStatuses = Object.keys(TransportStatuses).map((key) => ({
    value: key,
    label: TransportStatuses[key],
}));